import React, { memo } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { ErrorOutline } from '@material-ui/icons';

import { Button } from '../../material-ui/Button';
import { IconButton } from '../../material-ui/IconButton';
import { ListItem, ListItemSecondaryAction, ListItemText } from '../../material-ui/List';
import { Tooltip } from '../../material-ui/Tooltip';
import { TYPES, useShowModal } from '../../../actions/modal';
import { setInitialOfp } from '../../../actions/systemOfMeasurement';
import { getTelex, preloadTelexSignatureUrl } from '../../../actions/telex';
import { TOOLTIP_ENTER_TOUCH_DELAY, TOOLTIP_LEAVE_TOUCH_DELAY } from '../../../service/constants';
import { useStyles } from './useStyles';

export const Ofp = memo(({ id, telegramId, isCurrent, primary, secondary, isPlnChanged }) => {
    const classes = useStyles(isCurrent)();
    const dispatch = useDispatch();
    const showModal = useShowModal();
    const { t: translate } = useTranslation();

    React.useEffect(() => {
        if (isCurrent) {
            dispatch(setInitialOfp(id));
        }
    }, [isCurrent]);

    const handleShowSignature = React.useCallback(
        (e) => {
            e.preventDefault();
            showModal(TYPES.SIGNATURE, { ofpId: id });
        },
        [id]
    );

    const handleShow = React.useCallback(() => {
        dispatch(preloadTelexSignatureUrl(`sign-ofp_${id}`));
        dispatch(getTelex({ id: telegramId, name: 'OFP', showPreview: isCurrent, ofpId: id }));
    }, [id, telegramId, isCurrent]);

    return (
        <ListItem className={classnames(isCurrent ? classes.selectedListStyle : classes.listStyle)}>
            <ListItemText
                primary={primary}
                secondary={secondary}
                primaryTypographyProps={{ className: classes.text }}
                secondaryTypographyProps={{ className: classes.text }}
            />
            <ListItemSecondaryAction className={classes.actions}>
                <>
                    {isPlnChanged && (
                        <IconButton>
                            <Tooltip
                                enterTouchDelay={TOOLTIP_ENTER_TOUCH_DELAY}
                                leaveTouchDelay={TOOLTIP_LEAVE_TOUCH_DELAY}
                                title={`${translate('tasks.aircraftChanged')}.${translate('tasks.earlierCfpNotPlan')}`}
                                placement="top"
                            >
                                <ErrorOutline className={classes.errorIcon} />
                            </Tooltip>
                        </IconButton>
                    )}
                    <Button variant="contained" onClick={handleShow}>
                        {translate('show')}
                    </Button>
                    {isCurrent || (
                        <Button variant="contained" color="primary" onClick={handleShowSignature} className={classes.selectButton}>
                            {translate('select')}
                        </Button>
                    )}
                </>
            </ListItemSecondaryAction>
        </ListItem>
    );
});

Ofp.displayName = 'Ofp';
